import { render, staticRenderFns } from "./RotorSail.vue?vue&type=template&id=39f4f999&scoped=true&"
import script from "./RotorSail.vue?vue&type=script&lang=js&"
export * from "./RotorSail.vue?vue&type=script&lang=js&"
import style0 from "./RotorSail.vue?vue&type=style&index=0&id=39f4f999&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f4f999",
  null
  
)

export default component.exports